<template>
  <vs-prompt
    :title="$t('Start_Activation')"
    @close="closeHandle"
    class="active-prompt"
    buttons-hidden
    :active.sync="dialogShow">
    <div class="con-exemple-prompt">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
      >
        <el-form-item
          prop="activeCode"
        >
          <el-input
            :placeholder="$t('Please_enter_the_activation_code')"
            v-model="form.activeCode"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-modules">
        <el-button
          type="text"
          @click="candelHandle"
        >{{$t('cancel')}}</el-button>
        <el-button
          type="primary"
          @click="submitHandle"
          :loading="loading"
        >{{$t('Confirm')}}</el-button>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import { setLocalStorage } from '@/utils/common';
import { activeUseCode } from '@/api/user.js';
export default {
  name: "activeCodeDialog",
  data() {
    let _this = this;
    return {
      dialogShow: false,
      form: {
        activeCode: '',
      },
      rules: {
        activeCode: [
          {required: true, message: _this.$t('Please_enter_the_activation_code'), trigger: 'blur'},
        ]
      },
      loading: false,
    }
  },
  methods: {
    setLocalStorage,
    candelHandle() {
      this.$refs.form.resetFields();
      this.dialogShow = false;
    },
    closeHandle(){
      this.dialogShow = false;
      this.$refs.form.resetFields();
    },
    submitHandle(){
      this.$refs.form.validate((valid) => {
        if(valid){
          let activeData = {
            activeCode: this.form.activeCode,
          };
          this.loading = true;
          activeUseCode(activeData).then((res) => {

            localStorage.setItem('token',res.data.token);
            console.log(res.data.cust);
            this.setLocalStorage('userInfo', res.data.cust);
            this.$store.commit('setUserInfo', res.data.cust);
            this.loading = false;
            this.$message({
              message: this.$t('Activation_successful'),
              type: 'success'
            });
            this.closeHandle();
            setTimeout(() => {
              this.$router.push({name: 'perfectInfo'});
            },500);
          }).catch((error) => {
            console.log(error);
            this.loading = false;
          });
        }else {
          console.log('no-pass');
        }
      })
    }
  },
}
</script>

<style lang="scss">
.active-prompt.con-vs-dialog {
  z-index: 1001;
  .vs-dialog .vs-dialog-header .dialog-title {
    color: #5E5873;
  }
  .btn-modules {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
